import InternalReference from './InternalReference.styled';

export default InternalReference;
